import { render, staticRenderFns } from "./GetWalletId.vue?vue&type=template&id=11564bb4"
import script from "./GetWalletId.vue?vue&type=script&lang=js"
export * from "./GetWalletId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports